import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Tabs, Spin } from 'antd';
import PageHeader from './PageHeader';
import { TM_IAD_ALERTS_DETAILS, FRAUD_IAD_ALERTS_DETAILS } from './constant';
import style from './index.scss';
import { PageContentTabs, TabContainer } from './styled';
import CustomerDetailsTab from './CustomerDetailsTab';
import AlertDetailsTab from './AlertDetailsTab';
import TransactionDetailsTab from './TransactionDetailsTab';
import ScoreExplainability from '../../tmCommon/ScoreExplainability';
import ProfileAndPeerComparison from '../../tmCommon/components/ProfileAndPeerComparison';
import { TM_FRAUD_SOURCE_STRINGS } from '../../../util/GlobalConstant';
import ExportHistory from '../../common/TransactionDetalis/ExportHistory';
import {
  TRANSACTION_HISTORY_MODULES as MODULES,
  resolveDownloadModule
} from '../../constants/commonConstants';

const { TabPane } = Tabs;
const validTabs = ['1', '2', '3', '4', '5', 'downloadHistory'];

const DetailedAlertInvestigation = ({
  apiActions,
  settings,
  match,
  location,
  isLoading,
  alertDetails,
  alertId = null,
  /* CM Integration */
  alertMetaSuffix,
  alertMetaPrefix,
  isEmbedded = false,
  sourceId,
  isFromCM = false,
  module,
  caseId
  /* --------------*/
}) => {
  const effectiveModule = module || resolveDownloadModule({ isFromCM });
  const { getAMLSCommonGlobalSettingsPageInfo } = apiActions;
  const locationSearch = location?.search || window.location.search;
  const urlParams = new URLSearchParams(locationSearch);
  const tabParam = urlParams.get('tab');
  const defaultTab = validTabs.includes(tabParam) ? tabParam : '1';
  const [activeTab, setActiveTab] = useState(defaultTab);

  useEffect(() => {
    const tab = urlParams.get('tab');
    if (tab && validTabs.includes(tab)) {
      setActiveTab(tab);
    } else {
      setActiveTab('1');
    }
  }, [locationSearch]);

  useEffect(() => {
    if (sourceId) {
      // tm 6
      // fraud 21

      if (
        sourceId === TM_FRAUD_SOURCE_STRINGS.FRAUDIAD ||
        sourceId === TM_FRAUD_SOURCE_STRINGS.RTFRAUDIAD ||
        sourceId === TM_FRAUD_SOURCE_STRINGS.RTFRAUDIAD_BATCH
      ) {
        getAMLSCommonGlobalSettingsPageInfo({
          pageId: FRAUD_IAD_ALERTS_DETAILS
        });
      }

      if (
        sourceId === TM_FRAUD_SOURCE_STRINGS.TMIAD ||
        sourceId === TM_FRAUD_SOURCE_STRINGS.TMIAD_RUN_INSTANCE
      ) {
        getAMLSCommonGlobalSettingsPageInfo({ pageId: TM_IAD_ALERTS_DETAILS });
      }
    } else {
      getAMLSCommonGlobalSettingsPageInfo({ pageId: TM_IAD_ALERTS_DETAILS });
    }
  }, [sourceId]);

  const componentsTabPane = (
    <Tabs activeKey={activeTab} onChange={setActiveTab}>
      <TabPane tab="Customer Details" key="1">
        {settings && (
          <CustomerDetailsTab
            settings={settings}
            alertId={alertId || match.params.alertId}
            sourceId={sourceId}
          />
        )}
      </TabPane>
      <TabPane tab="Transaction Details" key="2">
        {settings && (
          <TransactionDetailsTab
            settings={settings}
            alertId={alertId || match.params.alertId}
            sourceId={sourceId}
            isFromCM={isFromCM}
            module={effectiveModule}
            caseId={caseId}
          />
        )}
      </TabPane>
      <TabPane tab="Alert Details" key="3">
        {settings && (
          <AlertDetailsTab
            settings={settings}
            alertId={alertId || match.params.alertId}
          />
        )}
      </TabPane>
      <TabPane tab="Score Explainability" key="4">
        <ScoreExplainability alertId={alertId || match?.params?.alertId} />
      </TabPane>
      <TabPane tab="Additional Information" key="5">
        <div className={style.tabContent}>
          <div className={style.secondaryTab}>
            <Tabs defaultActiveKey="2">
              {/* <TabPane tab="In/Out Transactions" key="1">
                 In/Out Transactions
               </TabPane> //TODO - Updated and Developed in future*/}
              <TabPane tab="Profile and peer comparison" key="2">
                <ProfileAndPeerComparison
                  alertId={alertId || match.params.alertId}
                  alertDetails={alertDetails}
                />
              </TabPane>
            </Tabs>
          </div>
        </div>
      </TabPane>
      <TabPane tab="Transaction Download History" key="downloadHistory">
        <ExportHistory
          alertId={alertId || match?.params?.alertId}
          isActive={activeTab === 'downloadHistory'}
          module={effectiveModule}
        />
      </TabPane>
    </Tabs>
  );

  return (
    <Spin size="large" spinning={isLoading}>
      <div className={style.root}>
        <div className={isEmbedded && style.pageContent}>
          <PageHeader
            sourceId={sourceId}
            settings={settings}
            alertId={alertId || match.params.alertId}
            {...{ alertMetaSuffix, alertMetaPrefix, isEmbedded }}
          />

          <TabContainer>
            {
              /* CM Integration */
              isEmbedded ? (
                <PageContentTabs> {componentsTabPane} </PageContentTabs>
              ) : (
                /* TRM Integration */
                componentsTabPane
              )
            }
          </TabContainer>
        </div>
      </div>
    </Spin>
  );
};

DetailedAlertInvestigation.propTypes = {
  apiActions: PropTypes.object.isRequired,
  settings: PropTypes.object,
  match: PropTypes.object,
  isLoading: PropTypes.bool,
  alertMetaSuffix: PropTypes.element,
  alertMetaPrefix: PropTypes.element,
  isEmbedded: PropTypes.bool
};

export default DetailedAlertInvestigation;
